import { render, staticRenderFns } from "./VerDetalleFuncionesGlobales.vue?vue&type=template&id=345ff930&"
import script from "./VerDetalleFuncionesGlobales.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleFuncionesGlobales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports